import { jsx as _jsx } from "react/jsx-runtime";
// -------------------------------------------------------
// NOTE: This is a generated file, do not manually modify!
// -------------------------------------------------------
import { SvgIcon } from '@mui/material';
const paths = [
    'M12.125 2.75H3.875C3.24219 2.75 2.75 3.26562 2.75 3.875V12.125C2.75 12.7578 3.24219 13.25 3.875 13.25H12.125C12.7344 13.25 13.25 12.7578 13.25 12.125V3.875C13.25 3.26562 12.7344 2.75 12.125 2.75ZM12.5 12.125C12.5 12.3359 12.3125 12.5 12.125 12.5H3.875C3.66406 12.5 3.5 12.3359 3.5 12.125V3.875C3.5 3.6875 3.66406 3.5 3.875 3.5H12.125C12.3125 3.5 12.5 3.6875 12.5 3.875V12.125Z',
];
export const CheckboxOff = (props) => (_jsx(SvgIcon, Object.assign({ viewBox: "0 0 16 16" }, props, { children: paths.map((pathString, i) => (_jsx("path", { d: pathString }, i))) })));
CheckboxOff.iconCategory = 'toggle';
